import React, {useEffect, useState} from 'react'
import {connect, useSelector} from "react-redux";


// components
import ScheduleFrom from "./_form";
import ScheduleContent from "./ScheduleContent";
import Grouper from "../../../../components/groupers/Grouper";
import {GenericButton} from "../../../../components/buttons/customButtons";

// actions
import {ADD_STATE, REMOVE_STATE, setForm, setItem, setItems} from "../../../../redux/actions/generics/IndexedActions";

// utils
import {getStateByPath} from "../../../../redux/selectors";


const Schedules = props => {
    const statePath = `${props.path}/schedules`;
    const {items, path} = props

    const componentState = useSelector(state => getStateByPath(state, statePath));
    const {listDomainObjects} = componentState?.data || [];
    const [showFormModal, setShowFormModal] = useState(false);


    useEffect(() => {
        props.ADD_STATE(statePath);

        return () => {
            props.REMOVE_STATE(statePath);
        }
    }, []);


    useEffect(() => {
        props.setItems(statePath, items)
    }, [items]);


    const onCreate = () =>{
        props.setItem(statePath, null);
        props.setForm(statePath)
        setShowFormModal(!showFormModal)
    };

    const handleShowFormModal = () => setShowFormModal(!showFormModal);

    const renderContent = schedule => <ScheduleContent
        key={schedule?.id}
        schedule={schedule}
        statePath={statePath}
        setShowFormModal={setShowFormModal}
    />

    return <>
        <div className={'top-right-header mb-2em'}>
            <GenericButton
                style={'table'}
                label={'Nuevo'}
                toolTip={'Genera un nuevo registro'}
                icon={'fa-plus'}
                permission={'add'}
                onClick={onCreate}
            />
        </div>

        <Grouper
            items={listDomainObjects || []}
            grouper={'grouper'}
            children={renderContent}
        />

        {
            showFormModal && <ScheduleFrom
                path={path}
                isOpen={showFormModal}
                toggle={handleShowFormModal}
            />
        }
    </>
}

const mapStateToProps = state => ({})
const mapActionsToProps = ({
    ADD_STATE,
    REMOVE_STATE,
    setItem,
    setForm,
    setItems
})

export default connect(mapStateToProps, mapActionsToProps)(Schedules)